export default __webpack_public_path__ + "static/media/anushka.41e82dee.jpg";